import EditIcon from '@mui/icons-material/Edit'

import { EditScenarioButtonProps } from './types'

const EditScenarioButton = ({
  isScenarioSelected,
  onClick
}: EditScenarioButtonProps) => {
  return (
    <button
      type='button'
      className='disabled:opacity-50'
      onClick={onClick}
      disabled={!isScenarioSelected}
    >
      <EditIcon />
    </button>
  )
}

export default EditScenarioButton
